<template>
  <div
    class="flex min-h-56 flex-1 items-center justify-center px-6 py-8 text-center"
    data-testid="inbox-notifications-empty-state"
    role="status"
  >
    <div
      class="flex max-w-sm flex-col items-center rounded-2xl border border-n-weak bg-n-surface-1 px-7 py-8 shadow-sm"
    >
      <span
        class="mb-3 flex size-12 items-center justify-center rounded-full bg-n-surface-2 text-[#15603e] dark:text-[#86efac]"
        aria-hidden="true"
      >
        <span class="i-lucide-bell-off size-6" />
      </span>
      <h2 class="text-base font-semibold text-n-slate-12">
        {{ $t('INBOX.CENTER.EMPTY_TITLE') }}
      </h2>
      <p class="mt-1 text-[13px] leading-relaxed text-n-slate-10">
        {{ $t('INBOX.CENTER.EMPTY_DESCRIPTION') }}
      </p>
    </div>
  </div>
</template>
